'use client';

import React, { useRef } from 'react';
import clsx from 'clsx';
import { setRef } from '../../../hooks';
import * as styles from './element.styles';

/**
 *
 * @type {typeof import('.').Element}
 */
const Element = React.forwardRef(
  ({ as: As = 'span', withEnterAsClick, className, typography, isInteractive, onKeyDown, disabled, lines, style, ...props }, ref) => {
    const innerRef = useRef(null);

    const onKeyDownHandler = (evt) => {
      if (['Space', 'Enter', 'NumpadEnter'].includes(evt.code)) {
        // Prevent page scrolling upon pressing Space
        evt.preventDefault();
        innerRef.current.click();
      }
      onKeyDown?.(evt);
    };
    return (
      <As
        ref={withEnterAsClick ? setRef(innerRef, ref) : ref}
        tabIndex={withEnterAsClick ? 0 : undefined}
        {...props}
        style={{ ...style, '--lines': lines }}
        disabled={disabled}
        {...(disabled && { tabIndex: -1 })}
        onKeyDown={withEnterAsClick ? onKeyDownHandler : onKeyDown}
        className={clsx(
          styles.element,
          {
            [styles.typographies[typography]]: typography,
            [styles.interactive]: isInteractive,
            [styles.lines]: lines,
          },
          className,
        )}
      />
    );
  },
);

if (process.env.NODE_ENV !== 'production') {
  Element.displayName = 'Element';
}

export default Element;
